import React, { useState } from "react";
import { MusicHallRegisContactInfoFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// field ในฟอร์ม -> field ของข้อมูลสมาชิก (customer/me)
const MEMBER_FIELD_MAP = {
  booker_first_name: "first_name",
  booker_last_name: "last_name",
  booker_email: "email",
  booker_phone: "phone_number",
};

const IS_SAME_AS_MEMBER = (values, memberInfo) => {
  if (!memberInfo) return false;
  return Object.entries(MEMBER_FIELD_MAP).every(
    ([formKey, memberKey]) =>
      !!memberInfo[memberKey] && values?.[formKey] === memberInfo[memberKey],
  );
};

const MusicHallRegisContactInfoForm = ({
  initialValues,
  isDisabledForm,
  memberInfo,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    booker_first_name: yup.string().required("required"),
    booker_last_name: yup.string().required("required"),
    booker_email: yup.string().email().required("required"),
    booker_phone: yup
      .string()
      .required("required")
      .matches(phoneRegExp, "Invalid phone number")
      .min(10, "Phone number must be 10 digits")
      .max(10, "Phone number must be 10 digits"),
  });

  const {
    clearErrors,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const { t } = useTranslation(["common", "form", "room"]);

  const [_isSameAsMember, _setIsSameAsMember] = useState(() =>
    IS_SAME_AS_MEMBER(initialValues, memberInfo),
  );

  // ติ๊ก = เติมข้อมูลสมาชิกให้ครบ, เอาติ๊กออกเอง = ล้างทุก field
  const _handleToggleSameAsMember = (checked) => {
    if (isDisabledForm) return;
    _setIsSameAsMember(checked);
    Object.entries(MEMBER_FIELD_MAP).forEach(([formKey, memberKey]) => {
      setValue(formKey, checked ? memberInfo[memberKey] || "" : "");
    });
    clearErrors(Object.keys(MEMBER_FIELD_MAP));
  };

  // ลูกค้าแก้ข้อมูลเอง = ไม่ใช่ข้อมูลสมาชิกแล้ว แต่ไม่ล้างสิ่งที่พิมพ์
  const _handleEditField = () => {
    _setIsSameAsMember((prev) => (prev ? false : prev));
  };

  return (
    <MusicHallRegisContactInfoFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        {memberInfo && (
          <div className="checkbox_wrap">
            <Inputs.InputCheckBox
              disabled={isDisabledForm}
              value={_isSameAsMember}
              label={t("Same as Member Information", { ns: "form" })}
              onChange={_handleToggleSameAsMember}
            />
          </div>
        )}
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={isDisabledForm}
                onChange={(e) => {
                  field.onChange(e);
                  _handleEditField();
                }}
                label={t("First Name", { ns: "form" })}
                // placeholder={t('test')}
                errors={errors.booker_first_name?.message}
              />
            )}
            name="booker_first_name"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={isDisabledForm}
                onChange={(e) => {
                  field.onChange(e);
                  _handleEditField();
                }}
                label={t("Last Name", { ns: "form" })}
                // placeholder={t('test')}
                errors={errors.booker_last_name?.message}
              />
            )}
            name="booker_last_name"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={isDisabledForm}
                onChange={(e) => {
                  field.onChange(e);
                  _handleEditField();
                }}
                label={t("Email (to receive the confirmation email.)", {
                  ns: "form",
                })}
                // placeholder={t('test')}
                errors={errors.booker_email?.message}
              />
            )}
            name="booker_email"
            defaultValue=""
          />
        </div>
        <div className="input_wrap mb_30">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={isDisabledForm}
                onChange={(e) => {
                  field.onChange(e);
                  _handleEditField();
                }}
                label={t("Mobile Phone Number", { ns: "form" })}
                // placeholder={t('test')}
                errors={errors.booker_phone?.message}
              />
            )}
            name="booker_phone"
            defaultValue=""
          />
        </div>
        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </MusicHallRegisContactInfoFormStyled>
  );
};

MusicHallRegisContactInfoForm.propTypes = {};

export default MusicHallRegisContactInfoForm;
